var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isMobile)?_c('div',{staticClass:"sm-overlay",class:{'sm-hidden' : _vm.curMode === 'category'},on:{"click":_vm.hideMe}}):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }